module.exports = __webpack_public_path__ + "static/media/stock19.76174929.jpg";